export { default as wordedPage } from './worded-page';
export { default as langSelector } from './lang-selector';
export { default as form } from './form';
export { default as backUrl } from './back-url';



// WEBPACK FOOTER //
// ./src/mixins/index.js